import { ContactNote } from "./notes/ContactNoteData";
import { AgTechContact, ContactDetails } from "./ContactData";
import { AgTechIndex, Index } from "@agtech/core/utilities/AgTechUtilities";
import { AgTechQuery, useAgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";
import AgTechQueryLoadingSurface from "@agtech/core/data/queries/AgTechQueryLoadingSurface";

/// DTOs

export type ContactDetailsDTO = {
    contact: AgTechContact,
    notes: ContactNote[]
}

///
/// Queries
///

export const ContactDataGetAllContactsQuery: AgTechQuery<any, AgTechIndex<AgTechContact>> = {
    queryKey: () => ['Contacts'],
    query: async (props) => {
        return await props.http.getEntity<AgTechContact[], AgTechIndex<AgTechContact>>({
            request: 'Contact',
            convert: (contacts) => {
                return Index(contacts, contact => contact.id);
            }
        });
    },
    content: {
        loadingText: 'Loading contacts...',
        failureText: 'Failed to load contacts.'
    }
}

export const ContactDataGetContactDetailsQuery: AgTechQuery<{ contactId: number }, ContactDetails> = {
    queryKey: ({ contactId }) => ['ContactDetails', contactId],
    query: (props) => {
        return props.http.getEntity({
            request: `Contact/${props.inputData.contactId}/Details`,
            convert: (dto: ContactDetailsDTO) => ({
                contact: dto.contact,
                notes: Index(dto.notes, note => note.id)
            })
        });
    },
    content: {
        loadingText: 'Loading contact details...',
        failureText: 'Failed to load contact details.'
    }
}

/// Providers

export const ContactDataProvider = (props: { 
    children: (contacts: AgTechIndex<AgTechContact>) => JSX.Element
}) => {
    const query = useAgTechQuery({
        query: ContactDataGetAllContactsQuery
    });

    return (
        <AgTechQueryLoadingSurface query={query}>
            {props.children}
        </AgTechQueryLoadingSurface>
    )
}

export const ContactDetailsDataProvider = (props: { 
    contactId: number,
    children: (contactDetail: ContactDetails) => JSX.Element
}) => {
    const query = useAgTechQuery({
        query: ContactDataGetContactDetailsQuery,
        queryContext: { contactId: props.contactId }
    });

    return (
        <AgTechQueryLoadingSurface query={query}>
            {props.children}
        </AgTechQueryLoadingSurface>
    )
}
